const TARGETS = [
  '.s-section__head',
  '.s-work-row',
  '.s-process__step',
  '.s-stack',
  '.s-contact__copy',
  '.s-contact__form',
].join(', ');

export function setupScrollReveal() {
  const els = Array.from(document.querySelectorAll<HTMLElement>(TARGETS));
  els.forEach((el) => el.classList.add('fx-reveal'));

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

  els.forEach((el) => io.observe(el));
}
